import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useBlocker } from 'react-router-dom';

export function useNavigationBlocker(
  shouldBlock: boolean,
  allowedRoutes: string[],
  onExit: () => void
): void {
  const { t } = useTranslation();
  const blocker = useBlocker(({ nextLocation }) => {
    const urlParams = new URLSearchParams(nextLocation.search);

    const id = urlParams.get('id');

    const isAllowedRoute = allowedRoutes.some(route => nextLocation.pathname.startsWith(route));

    return (
      shouldBlock &&
      !isAllowedRoute &&
      !allowedRoutes.includes(nextLocation.pathname.concat(`?id=${id}`))
    );
  });

  useEffect(() => {
    const handleBeforeUnload = (e: any) => {
      if (shouldBlock) {
        const message = t(
          '¿Estás seguro que quieres salir? Se pueden perder los cambios no guardados'
        );
        e.preventDefault();
        e.returnValue = message;
        return message;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    if (blocker.state === 'blocked' && shouldBlock) {
      const confirmNavigation = window.confirm(
        t('¿Estás seguro que quieres salir? Se pueden perder los cambios no guardados')
      );
      if (confirmNavigation) {
        onExit();
        blocker.proceed();
      }
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [blocker, onExit, shouldBlock]);
}
